// NPM imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Action imports
import {
  changeToolsView,
  getClausesForDealTable,
  reOrderDocumentSectionList,
} from "../../actions/DocumentActions";

import NotesActions from "../../actions/NotesActions";

// Import services
import {
  addDocumentComponentService,
  deleteDocumentComponentService,
  updateDocumentComponentService,
  updateDocumentOrder,
} from "../../actions/DocumentActions/services";
// Import utils
import { checkAcceptRejectNotes } from "../../utils/documentUtils";

import Document from "../Document";
// import IFrameSignature from "../IFrameSignature";

const { addNote } = NotesActions;

// Components Imports
class DocumentWrapper extends Component {
  state = {};

  componentWillMount() {
    const { dealTable, isSharedDocument } = this.props;
    // Need to remove "isSharedDocument" later
    if (
      !isSharedDocument &&
      dealTable !== null &&
      dealTable !== undefined &&
      dealTable.id !== undefined
    ) {
      this.props.getClausesForDealTable(dealTable.id);
    }
  }

  componentDidUpdate(prevProps) {
    const { dealTable, isSharedDocument } = this.props;
    // Need to remove "isSharedDocument" later
    if (
      !isSharedDocument &&
      dealTable !== prevProps.dealTable &&
      dealTable !== null &&
      dealTable !== undefined &&
      dealTable.id !== undefined
    ) {
      this.props.getClausesForDealTable(dealTable.id);
    }
  }

  _addNote = note => {
    this.props.addNote(note);
    this.props.changeToolsView("notes");
  };

  render() {
    const {
      mode,
      acceptRejectChanges,
      isLocked,
      reOrderSectionListAction,
      // showIframeView,
      isSharedDocument,
    } = this.props;
    if (acceptRejectChanges) {
      this.props.changeToolsView("notes");
    }
    // if (showIframeView) {
    //   return <IFrameSignature />;
    // }
    return (
      <Document
        {...this.props}
        mode={mode}
        addNote={this._addNote}
        sharingHash={this.props.sharingHash}
        isLocked={isLocked || acceptRejectChanges}
        addNewSectionService={addDocumentComponentService}
        deleteSectionService={deleteDocumentComponentService}
        updateSectionService={updateDocumentComponentService}
        reOrderSectionListAction={reOrderSectionListAction}
        reOrderSectionListService={updateDocumentOrder}
        isSharedDocument={isSharedDocument}
        signatureWrapperRef={this.props.signatureWrapperRef}
        isSharedDocumentPerma={this.props.isSharedDocumentPerma}
      />
    );
  }
}

const mapStateToProps = state => {
  const { document } = state.DocumentStore;
  const { id: docID, dealTable, isLocked } = document;
  const { documentNotes } = state.NotesStore;
  const acceptRejectChanges = checkAcceptRejectNotes(documentNotes);

  return {
    acceptRejectChanges,
    dealTable,
    docID,
    isLocked,
    //  showIframeView,
  };
};

const mapDispatchToProps = {
  addNote,
  changeToolsView,
  reOrderSectionListAction: reOrderDocumentSectionList,
  getClausesForDealTable,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentWrapper);



// WEBPACK FOOTER //
// ./src/components/DocumentWrapper/DocumentWrapper.js